import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da7b0140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "donate-container" }
const _hoisted_2 = { class: "header-item" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "amount-buttons" }
const _hoisted_6 = { class: "payment-qrcode" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "payment-status"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-zhifuchenggong" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "支付成功！谢谢您的捐赠！")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "qr-img"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-method-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-weixin1" }),
  /*#__PURE__*/_createElementVNode("span", null, "请使用微信扫码支付")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-right" }, " 捐赠本站能使本站发展更长久！ ", -1))

import { checkPaymentStatus, getDonationQR } from '@/api/user'
import { ERR_SUCCESS } from '@/api/config'
import { onUnmounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'donate',
  setup(__props) {

const donationAmounts = [1, 10, 20, 30, 50, 100, 200, 500]
const selectedAmount = ref<number>(50)
const paymentQRCode = ref<string>('')
const paymentStatus = ref<number>(0)
const paymentId = ref<string>('')

let pollingInterval: number | null = null

const checkPaymentStatusAPI = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/camelcase
    const response = await checkPaymentStatus({ donate_id: paymentId.value })
    if (response.code === ERR_SUCCESS) {
      paymentStatus.value = response.result.pay_status // 假设后端返回了支付状态
    }
  } catch (error) {
    console.error('Error checking payment status: ', error)
  }
}

const startPollingPaymentStatus = () => {
  if (!pollingInterval) {
    pollingInterval = setInterval(checkPaymentStatusAPI, 7000)
  }
}

const stopPollingPaymentStatus = () => {
  if (pollingInterval !== null) {
    clearInterval(pollingInterval)
    pollingInterval = null
  }
}

const fetchQR = async () => {
  try {
    const params = { fee: selectedAmount.value, title: '捐赠课·视频网站' }
    const { code, result } = await getDonationQR(params)
    if (code === ERR_SUCCESS) {
      paymentQRCode.value = result.QRcode_url
      paymentId.value = result.donate_id
      startPollingPaymentStatus()
    }
  } catch (error) {
    console.error('Error fetching payment QR code:', error)
  }
}

const setDonateAmount = (amount: number) => {
  if (selectedAmount.value !== amount) {
    stopPollingPaymentStatus()
    selectedAmount.value = amount
    paymentStatus.value = 0
    fetchQR()
  }
}

onUnmounted(() => {
  stopPollingPaymentStatus()
})

watch(selectedAmount, fetchQR, { immediate: true })
watch(paymentStatus, (newValue) => {
  if (newValue === 1) stopPollingPaymentStatus()
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { style: {"max-width":"360px"} }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (selectedAmount.value)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_3, [
                _createTextVNode("捐赠："),
                _createElementVNode("span", null, _toDisplayString(selectedAmount.value) + "元", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_4, "选择捐赠金额"))
        ])
      ]),
      footer: _withCtx(() => [
        _hoisted_15
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(donationAmounts, (amount) => {
            return _createVNode(_component_el_button, {
              key: amount,
              type: selectedAmount.value === amount ? 'primary' : 'success',
              onClick: ($event: any) => (setDonateAmount(amount))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(amount) + " 元 ", 1)
              ]),
              _: 2
            }, 1032, ["type", "onClick"])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (paymentQRCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (paymentStatus.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: paymentQRCode.value,
                        alt: "Payment QR Code"
                      }, null, 8, _hoisted_13),
                      _hoisted_14
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})